import React, { useEffect } from 'react';

function HomeVideo() {
  useEffect(() => {
    const video = document.getElementById('background-video');

    if (!video) {
      console.error('Video element not found!');
      return;
    }

    const onCanPlayThrough = () => {
      video.play();
    };

    const onEnded = () => {
      video.currentTime = 0;
      video.play();
    };

    video.addEventListener('canplaythrough', onCanPlayThrough);
    video.addEventListener('ended', onEnded);

    return () => {
      video.removeEventListener('canplaythrough', onCanPlayThrough);
      video.removeEventListener('ended', onEnded);
    };
  }, []);

  return (
    <div id="container-video">
      <video
        id="background-video"
        poster="./images/1.jpg"
        style={{ filter: 'blur(5px)', transform: 'scale(1.05)' }}
        playsInline
        autoPlay
        loop
        muted
      >
        <source src="./videos/home-video.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
}

export default HomeVideo;